import React from 'react'
import styled from 'styled-components'
import {useStaticQuery, graphql} from 'gatsby'

export default () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "about_main_top.jpeg" }) {
        childImageSharp{
          fluid {
            src
          }
        }
      }
    }
  `)
  return (
    <Container img={data?.file?.childImageSharp?.fluid?.src}/>
  )
}

const Container = styled.div`
  position: absolute;
  width: 50%;
  height: 60%;
  top: -5rem;
  left: 1rem;
  border-radius: 10px;
  background-color: rgba(222, 218, 218, 0.1);
  background-image: url('${props => props.img}');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-blend-mode: color;
  z-index: 1;
  @media(min-width: 900px) {
    left: -1rem;
    height: 70%;
  }
  @media(min-width: 1100px) {
    height: 90%;
  }
  @media(min-width: 1300px) {
    width: 30rem;
    margin: 0 auto;
    height: 30rem;
  }
`